import { useEffect } from "react";
import { useHolidayBannerStore } from "zustand_store";

interface UseHolidayBannerReturnInterface {
  loading: boolean;
  field_hbanner_short_description: boolean;
  field_holiday_banner_link: boolean;
  field_imageholiday: boolean;
}

const useHolidayBanner = (): UseHolidayBannerReturnInterface => {
  const {
    field_hbanner_short_description,
    field_holiday_banner_link,
    field_imageholiday,
    loading,
    getHolidayBanner,
  } = useHolidayBannerStore();

  const dispatchFetchHolidayBanner = async (): Promise<void> => {
    await getHolidayBanner();
  };

  useEffect(() => {
    dispatchFetchHolidayBanner();
  }, []);

  return {
    loading,
    field_hbanner_short_description,
    field_holiday_banner_link,
    field_imageholiday,
  };
};

export default useHolidayBanner;
